<template>
  <div class="legal-page-hero">
    <h1 class="legal-page-hero__title">{{ title }}</h1>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  title: {
    type: String,
    required: true,
  },
});
</script>

<style scoped>
.legal-page-hero {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 200px;
  padding: 24px 80px;
  background: var(--primary-purple);
  border-radius: 0 0 64px 64px;
  overflow: hidden;
}

.legal-page-hero__title {
  margin: 0;
  max-width: 410px;
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-display-large);
  line-height: var(--line-height-display-large);
  letter-spacing: -0.1425px;
  color: var(--white);
  word-break: break-word;
}

@media (max-width: 768px) {
  .legal-page-hero {
    min-height: 124px;
    height: 124px;
    padding: 24px 16px;
    border-radius: 0;
  }

  .legal-page-hero__title {
    max-width: none;
    font-size: var(--font-size-headline-small);
    line-height: var(--line-height-headline-small);
    letter-spacing: 0;
  }
}
</style>
